<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div class="col-lg-3 col-6 mt-2">
                <div class="input-group">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                    </div>
                    <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput" ref="searchInput"
                           v-model="searchString">
                </div>
            </div>
            <div class="col-lg-3 col-6 text-center">
                <button class="btn btn-success m-2" @click="newClicked">+ سند حسابداری جدید</button>
            </div>
            <div class="col-lg-6 col-12 mt-2">
                <div class=" d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <button type="button" class="d-inline-block btn btn-success mr-2" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <div class="input-group-prepend " @click="toggleStartDatePicker">
                            <div class="input-group-text"><span>از تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                     ref="datePickerStart" style="flex: 1">
                            <slot>
                                <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleStartDatePicker">
                                <button class="close reset-date" @click="resetStartDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="d-inline-block">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleEndDatePicker">
                            <div class="input-group-text"><span>تا تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                     @input="onEndDatePicked"
                                     ref="datePickerEnd" style="flex: 1; transform">
                            <slot>
                                <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleEndDatePicker">
                                <button class="close reset-date" @click="resetEndDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
            </div>

            <div class="col-12" id="printMe">
                <div class="table-responsive" v-if="vouchers !== undefined && vouchers.length>0">
                    <table class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th class="text-center text-nowrap">شماره سند حسابداری</th>
                            <th class="text-center text-nowrap">تاریخ</th>
                            <th class="text-center text-nowrap">نوع سند</th>
                            <th class="text-center text-nowrap">کاربر</th>
                            <th class="text-center text-nowrap">شماره فاکتور</th>
                            <th class="text-center text-nowrap">توضیحات</th>
                            <th class="text-center text-nowrap">مبلغ کل</th>
                            <th class="text-center text-nowrap">عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in vouchers">

                            <td class="text-center">{{item.accountNumber1}}</td>
                            <td class="text-center">{{item.fvoucherDate}}</td>
                            <td class="text-center">{{item.fvoucherType}}</td>
                            <td class="text-center">{{item.userFullName}}</td>
                            <td class="text-center">{{item.voucherNumber}}</td>
                            <td class="text-center">{{item.description}}</td>
                            <td class="text-center">{{item.price.toLocaleString()}}</td>
                            <td class="text-center" v-if="item.voucherType ===20">
                                <button class="btn btn-danger" @click="editItem(item)"><i class="fa fa-pencil"></i></button>
                                <button class="btn btn-danger" @click="deleteItem(item)"><i class="fa fa-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>


            </div>
            <div class="col-12">
                <div v-if="vouchers === undefined|| vouchers.length===0" class="col-lg-12 text-center mt-5 mb-3">
                    <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
                </div>
                <div v-if="vouchers !== undefined && vouchers.length < dataCount" class="col-lg-12 text-center my-3">
                    <button class="btn btn-success" @click="getTransactions">نمایش اسناد بیشتر
                        ({{vouchers.length}}/{{dataCount}})
                    </button>
                    <div class="col-2 offset-5 my-2">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تعداد نمایش</span>
                            </div>
                            <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect"
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from 'moment-jalali';
    import VueHtmlToPaper from 'vue-html-to-paper';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'accountPaymentList',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                voucherTypes: [],
                mainAccounts: [
                    {id: 0, title: "همه حسابها"},
                    {id: 1, title: "بانکها"},
                    {id: 2, title: "صندوق ها"},
                    {id: 3, title: "مشتری ها"},
                    {id: 5, title: "تامین کننده ها"},
                    {id: 6, title: "سرمایه(موجودی اولیه)"},
                    {id: 7, title: "درآمدها"},
                    {id: 8, title: "هزینه ها"},
                    // {id: 9, title: "تولید"},
                    {id: 10, title: "فروش"},
                    {id: 11, title: "خرید"},
                    {id: 12, title: "چک های دریافتی"},
                    {id: 13, title: "چک های پرداختی"},
                    {id: 20, title: "سایر سرفصلها"},
                    // {id: 14, title: "فروش اینترنتی"},
                ],
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    // type: 20
                },
                vouchers: [],
                dataCount: 0,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",
                searchString: "",

            }
        },
        mounted() {
            const cc = localStorage.getItem("salemali_close");
            if (cc !== undefined && cc != null && cc === "true") {
                Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
            }
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);


            this.getTransactions(-1);
            this.getVoucherTypes();
        },
        methods: {
            getVoucherTypes() {
                new BaseService('Enum', '/GetEnVoucherTypes').getList().then(response => {
                    this.voucherTypes = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            changePageSize(e) {
                this.getTransactions(-1);
            },
            getTransactions(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loading").show();
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    this.vouchers.push.apply(this.vouchers, response.data.data);
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                    for (let item of this.vouchers) {
                        item.fvoucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        for (let vt of this.voucherTypes) {
                            if (item.voucherType === vt.value) {
                                item.fvoucherType = vt.title;
                            }
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                // new BaseService('account','/getPaymentList').getList().then(response => {
                //      console.log(response)
                // }).catch(error => {
                //     this.isSending = false;
                //     Utils.handleErrorWithNotification(error.data.message, this.$noty);
                // });
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                // this.queryParams.accountTitleId = this.selectedBank !== 0 ? this.selectedBank : this.selectedCash;
                if(this.fromDate!== "") {
                    this.queryParams.from = this.fromDate;
                    this.queryParams.to = this.toDate;
                    this.getTransactions(-1);
                }
            },
            resetStartDate() {
                this.fromDate = "";
                this.startDatePersian = "";
            },
            resetEndDate() {
                this.toDate = "";
                this.endDatePersian = "";
            },
            onSearchInput() {
                if (this.searchString.length > 2) {
                    this.queryParams.name= this.searchString;
                } else {
                    this.queryParams.name="";
                }
                this.getTransactions(-1);
            },

            newClicked() {
                this.$router.push({name: 'addPayment',});
            },
            editItem(i) {
                new BaseService('Voucher', `/GetVoucherJournals/${i.id}`).getList().then(response => {
                    if (response.data != null) {
                        this.$router.push(
                            {
                                name: 'addPayment',
                                params: {
                                    voucher: response.data
                                }
                            }
                        );
                    }

                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
            },
            deleteItem(i) {
                if (confirm("آیا حذف سند را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteVoucher/${i.id}`).create().then(response => {
                        this.$noty.success('سند با موفقیت حذف شد');
                        this.getTransactions(-1);
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },


        },

        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#payment").hasClass("show")) {
                $("#payment").modal("hide");
                next(false);
            } else {
                if ($("#check").hasClass("show")) {
                    $("#check").modal("hide");
                    next(false);
                } else {
                    if ($("#customer").hasClass("show")) {
                        $("#customer").modal("hide");
                        next(false);
                    } else {
                        if ($("#transaction").hasClass("show")) {
                            $("#transaction").modal("hide");
                            next(false);
                        } else {
                            next();
                        }
                    }
                }
            }


        },
    }
</script>